import { usePeopleAndTeamsConfigurationContext, withMandatoryPeopleAndTeamsConfiguration } from '../../provider';
const KEY = 'people-menu';
export const usePeopleAndTeamsPeopleMenuConfiguration = () => {
  const configuration = usePeopleAndTeamsConfigurationContext();
  return configuration[KEY];
};
export const withMandatoryPeopleMenuConfiguration = WrappedComponent => withMandatoryPeopleAndTeamsConfiguration(WrappedComponent, KEY);